import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const WeekLogo = ({ color = 'currentColor', textColor = '#00F', className = null }) => (
    <svg
        // width="392.1px"
        // height="263.5px"
        viewBox="0 0 392.1 263.5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fill={color}
            d="M366.1,0c-3.9,0-7.7.9-11,2.4L9.8,133c-5.7,2.3-9.8,7.9-9.8,14.4v100.6c0,8.6,6.9,15.5,15.5,15.5h235.2c5.9,0,11-3.3,13.7-8.2l124.4-216.4c2.2-3.8,3.4-8.2,3.4-12.9,0-14.4-11.7-26-26-26Z"
        />
        <g>
            <path fill={textColor} d="M11.9,146.8h8.3v23.6h9v7.4H11.9v-31Z" />
            <path
                fill={textColor}
                d="M39.1,146.8h11l8.8,31h-9l-1.2-5.2h-8.5l-1.2,5.2h-8.7l8.8-31ZM41.8,165.4h5.1l-2.4-10.4h-.2l-2.5,10.4Z"
            />
            <path
                fill={textColor}
                d="M21,194l5.9,3.6c2.2,1.3,4.8,3.9,4.8,8.6s-4.4,9.4-10.5,9.4-10-4.1-10.8-8.9l7.2-2.9c.4,1.4,1.2,4.3,3.7,4.3s1.9-1,1.9-1.9-.3-1.6-1.8-2.5l-5-3.1c-2.1-1.3-5.1-3.1-5.1-8.3s3.7-9.1,9.8-9.1,9,2.9,10.5,7.6l-7.1,2.7c-1.2-2.6-2.4-3.1-3.4-3.1s-1.6.5-1.6,1.4.8,1.6,1.5,2Z"
            />
            <path
                fill={textColor}
                d="M36.1,184h18.8v7.2h-10.4v4.6h9.6v7.1h-9.6v4.7h10.6v7.4h-19v-31Z"
            />
            <path
                fill={textColor}
                d="M72,208.9l-4.3-10.4h-.2v16.4h-8v-31h10.2l5.5,14.1h.2l5.9-14.1h9.7v31h-7.9v-16.4h-.2l-4.3,10.4h-6.7Z"
            />
            <path
                fill={textColor}
                d="M102.8,184h11l8.8,31h-9l-1.2-5.2h-8.5l-1.2,5.2h-8.7l8.8-31ZM105.6,202.6h5.1l-2.4-10.4h-.2l-2.5,10.4Z"
            />
            <path fill={textColor} d="M125.5,184h8.3v31h-8.3v-31Z" />
            <path
                fill={textColor}
                d="M157,215l-9.7-15.9h-.2v15.9h-8v-31h8.5l9.5,15.9h.2v-15.9h8v31h-8.3Z"
            />
            <path
                fill={textColor}
                d="M170.6,184h18.8v7.2h-10.4v4.6h9.6v7.1h-9.6v4.7h10.6v7.4h-19v-31Z"
            />
            <path
                fill={textColor}
                d="M11.9,252.2v-31h11c9.2,0,15.9,6.1,15.9,15.5s-6.8,15.5-15.9,15.5h-11ZM30.2,236.7c0-5.2-2.9-8.2-7.4-8.2h-2.6v16.4h2.6c4.4,0,7.4-2.9,7.4-8.2Z"
            />
            <path
                fill={textColor}
                d="M67.3,240.7c0,7.1-4.7,12.2-12.4,12.2s-12.4-5-12.4-12.2v-19.5h8.3v20.2c0,2.4,1.7,4,4,4s4-1.7,4-4v-20.2h8.3v19.5Z"
            />
            <path
                fill={textColor}
                d="M81.3,252.2v-31h11c9.2,0,15.9,6.1,15.9,15.5s-6.8,15.5-15.9,15.5h-11ZM99.7,236.7c0-5.2-2.9-8.2-7.4-8.2h-2.6v16.4h2.6c4.4,0,7.4-2.9,7.4-8.2Z"
            />
            <path
                fill={textColor}
                d="M111,236.7c0-9.5,6.5-16.2,15.8-16.2s15.9,6.6,15.9,16.2-6.5,16.2-15.9,16.2-15.8-6.6-15.8-16.2ZM134.1,236.7c0-5.3-2.6-8.7-7.3-8.7s-7.3,3.3-7.3,8.7,2.6,8.6,7.3,8.6,7.3-3.3,7.3-8.6Z"
            />
            <path
                fill={textColor}
                d="M168.3,231.8c-1.5-2.4-4.2-3.8-7.1-3.8-4.5,0-7.3,3.3-7.3,8.7s2.7,8.6,7.3,8.6,5.6-1.4,7.1-3.8l5.5,4.9c-2.6,4.1-6.9,6.4-12.6,6.4-9.8,0-15.8-6.6-15.8-16.2s6.5-16.2,15.8-16.2,10.2,2.4,12.8,6.5l-5.7,4.8Z"
            />
        </g>
    </svg>
);

WeekLogo.propTypes = propTypes;

export default WeekLogo;
